export default {
  me: {
    method: 'GET',
    url: '/users/me',
  },
  list: {
    method: 'GET',
    url: '/users',
  },
  create: {
    method: 'POST',
    url: '/users',
  },
  show: {
    method: 'GET',
    url: 'users/:id',
  },
};
